import { sharedConfig } from '@/pageConfig/shared';
import ogImage from '@/static/og_image_uk.png';
import { DocumentTypes } from 'contentlayer/generated';
import type { Config } from '..';
import content from '../../../../.contentlayer/generated/PrivacyPolicy/privacyPolicy__en-GB.mdx.json';

export const config: Config = {
  layout: { ...sharedConfig['en-GB'].layout },
  seo: {
    ...sharedConfig['en-GB'].seo,
    title: 'Privacy Policy • Lemonade Home Insurance UK',
    metaTitle: 'Privacy Policy • Lemonade Home Insurance UK',
    description:
      "Lemonade UK's Privacy Policy is in place to protect you. Keeping your information private and secure is of utmost importance to us.",
    ogImage: ogImage.src,
  },
  MDXContent: content as DocumentTypes,
};
